import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static values = {
    autoOpen: { type: Boolean, default: true }
  }

  connect() {
    const element = $(this.element)
    element.modal({ show: false })
    this.modal = element.data("bs.modal")
    this.hideOnSuccessfulSubmit = (event) => {
      if (event.detail.success) this.modal.hide()
    }
    this.element.addEventListener("turbo:submit-end", this.hideOnSuccessfulSubmit)
    if (this.autoOpenValue) this.modal.show()
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.hideOnSuccessfulSubmit)
    this.modal.hide()
    this.modal.dispose()
  }
}
